import React from "react";
import { useState } from "react";
import axios from "axios";
import { InputProps } from "../form_components/Input";

interface ConfigProps {
    post: string;
    children: React.ReactNode;
};

export default function ConfigFormComponent({ post, children }: ConfigProps) {
    const [formValues, setFormValues] = useState<Record<string, string | boolean>>({});

    const resetFormValues = () => {
        setFormValues(prevValues => {
            const resetValues = Object.keys(prevValues).reduce((acc, key) => {
                acc[key] = typeof prevValues[key] === "boolean" ? false : '';
                return acc;
            }, {} as Record<string, string | boolean>);
            return resetValues;
        });
    };

    const updateFormValues = (field: string, value: string | boolean) => {
        setFormValues(prevValues => ({
            ...prevValues,
            [field]: value,
        }));
    };

    const onClick = async (e: React.MouseEvent) => {
        e.preventDefault();
        try {
            const response = await axios.post(process.env.REACT_APP_API_URI + post, formValues);

            resetFormValues();
        } catch (error) {
            console.error("Project creation failed:", error);
            if (error instanceof Error) {
                console.error("Error message:", error.message);
            } else {
                console.error("An unknown error occurred.");
            }
            if (axios.isAxiosError(error) && error.response) {
                console.error("Server responded with:", error.response.data);
            }
        }
    };

    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement<InputProps>(child) && child.props.name) {
            const childOnChange = child.props.onChange;

            const composedOnChange = (name: string, value: string | boolean) => {
                updateFormValues(name, value);
                if (childOnChange) childOnChange(name, value);
            };

            const nextValue =
                formValues[child.props.name] ??
                (child.props.type === "checkbox" ? false : "");

            return React.cloneElement(child, {
                value: nextValue,
                onChange: composedOnChange,
            });
        }

        return child;
    });

    return (
        <>
            <form>
                {childrenWithProps}
            </form>
            {process.env.REACT_APP_DEBUG === "true" ? (
                <div className="p-4 bg-gray-100 rounded shadow">
                    <pre>{JSON.stringify(formValues, null, 2)}</pre>
                </div>
            ) : null}
        </>
    )
}